module.exports = __webpack_public_path__ + "static/media/PA-Icon-Baby-neg.8cda6207.svg";